import "./dashboard-sections.css";

const DUMMY = {
  total_peelers:  45,
  cases_per_cart: 120,
};

const Operations = ({ data = DUMMY, isLoading = false }) => (
  <div className="cmn_card ops-card">
    <div className="ops-header">
      <span className="ops-icon">📊</span>
      <span className="ops-title">OPERATIONS</span>
    </div>
    <div className="ops-grid">
      <div className="ops-cell">
        <div className="ye-label">TOTAL PEELERS</div>
        <div className="ops-value">
          {data.total_number_of_peelers}
          <span className="ops-active-badge">ACTIVE</span>
        </div>
      </div>
      <div className="ops-cell">
        <div className="ye-label">CASES PER CART</div>
        <div className="ops-value">{data.cases_per_cart}</div>
      </div>
    </div>
  </div>
);

export default Operations;
